import React from "react";
import {
  Button,
  Collapsible,
  CollapsibleHeading,
  CollapsibleContent,
  Heading,
} from "@americanexpress/dls-react";
import { withTranslation } from "react-i18next";
import addIcon from "../../assets/plus.svg";
import ArrowIcon from "../../assets/Arrow.svg";
import PersonalDetails from "./newpersonalDetails";

class PersonalDetailsAccordianComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addNewUser: false,
      disabled: false,
      prev: "",
      newarr: [],
      backButton: false,
    };
  }

  componentDidMount() {
    if (this.props.history.location.state !== undefined) {
      this.setState({
        prev: this.props.history.location.state[3],
        newarr: this.props.history.location.state[4],
      });
    }
  }

  disable = (val) => {
    this.setState({ disabled: val }, () => {});
  };

  addNewUserhandler = () => {
    this.setState({ addNewUser: true });
  };

  handleBackButton = () => {
    this.setState({ backButton: true });
  };

  Next = () => {
    if (this.props.modifyUser) {
      this.props.history.push("/access-approver", [
        this.props.users,
        this.state.minutes,
        this.state.seconds,
        this.state.prev,
        this.props.modifyUser,
        undefined,
        this.state.newarr,
        this.props.showCheckBox,
        this.props.modifyCheckBox,
      ]);
    } else {
      this.props.history.push("/access-approver", [
        this.props.users,
        this.state.minutes,
        this.state.seconds,
        this.state.prev,
        this.props.modifyUser,
        undefined,
        this.state.newarr,
      ]);
    }
  };

  render() {
    const {
      t,
      history,
      accesses,
      modifyUser,
      setShowAllUsers,
      users,
      setUsers,
      resetAction,
    } = this.props;

    const showCheckBox =
      this.props.history.location.state !== undefined
        ? this.props.history.location.state[5]
        : this.props.showCheckBox;
    const modifyCheckBox =
      this.props.history.location.state !== undefined
        ? this.props.history.location.state[6]
        : this.props.modifyCheckBox;
    const { addNewUser } = this.state;

    return (
      <>
        <section id="personal-details-accordion" className="mainBody">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-xs-12">
                {this.state.backButton &&
                  users.map((user, index) => (
                    <div className="nestedUsers margin-1-t" key={index}>
                      <PersonalDetails
                        key={index}
                        userNumber={index + 1}
                        selectedIndex={index}
                        user={user}
                        history={history}
                        accesses={accesses}
                        modifyUser={modifyUser}
                        setShowAllUsers={setShowAllUsers}
                        showAllUsers={true}
                        setUsers={setUsers}
                        showCheckBox={showCheckBox}
                        modifyCheckBox={modifyCheckBox}
                        showDeleteUser={true}
                        deleteUser={(selectedInd) =>
                          this.props.deleteUser(selectedInd)
                        }
                        resetAction={resetAction}
                        disable={(val) => this.disable(val)}
                        prev={this.props.prev}
                      />
                    </div>
                  ))}

                {!this.state.backButton && (
                  <>
                    <Heading
                      level={1}
                      headingStyle={"heading5"}
                      className="margin-1-b"
                    >
                      {this.props.modifyUser
                        ? t("newuser.modifyheading")
                        : t("newuser.newUserHeading")}
                    </Heading>
                    <div id="userMultiple" className="accordianBody">
                      <Collapsible defaultOpen={[]}>
                        {this.props.i18n.language === "en" && (
                          <div className="legal1 pad-1-b">
                            Prior to application submission you will be asked to
                            Confirm Details which can be edited.
                          </div>
                        )}
                        <Heading level={4} headingStyle={"heading2"}>
                          {t("newuser.listOfUsers")}
                        </Heading>
                        {users.map((user, index) => (
                          <div className="pad-1-tb" key={index}>
                            <CollapsibleHeading
                              id={index}
                              className="dls-bright-blue-bg dls-white width100"
                              defaultBtn={true}
                            >
                              <div className="col-sm-12 row pad-1-tb">
                                <div className="col-sm-3">
                                  {t("newuser.user")} {index + 1}
                                </div>
                                <div className="col-sm-3">
                                  {this.props.i18n.language === "en"
                                    ? `${user.firstName} ${user.lastName}`
                                    : `${user.lastName} ${user.firstName}`}
                                </div>
                                <div className="col-sm-3">
                                  {t("newuser.numberofaccess")}{" "}
                                  {`${user.access.length}`}
                                </div>
                                <div className="col-sm-3">
                                  {t("access.viewdetails")}{" "}
                                  <img
                                    style={{ paddingLeft: "7px" }}
                                    src={ArrowIcon}
                                    alt="arrowicon"
                                  />
                                </div>
                              </div>
                            </CollapsibleHeading>

                            <CollapsibleContent
                              labelledBy={index}
                              style={{ overflowY: "auto" }}
                            >
                              <div className="nestedUsers" key={index}>
                                <PersonalDetails
                                  key={index}
                                  selectedIndex={index}
                                  user={user}
                                  history={history}
                                  accesses={accesses}
                                  modifyUser={modifyUser}
                                  setShowAllUsers={setShowAllUsers}
                                  showAllUsers={true}
                                  setUsers={setUsers}
                                  showCheckBox={showCheckBox}
                                  modifyCheckBox={modifyCheckBox}
                                  showDeleteUser={true}
                                  deleteUser={(selectedInd) =>
                                    this.props.deleteUser(selectedInd)
                                  }
                                  resetAction={resetAction}
                                  disable={(val) => this.disable(val)}
                                  prev={this.props.prev}
                                />
                              </div>
                            </CollapsibleContent>
                          </div>
                        ))}
                      </Collapsible>

                      {!addNewUser && (
                        <Button
                          onClick={this.addNewUserhandler}
                          className="addbtn margin-1-t margin-2-b"
                        >
                          <img
                            src={addIcon}
                            alt="Add Icon"
                            width="10"
                            className="pad-1-r"
                          />
                          {t("newuser.adduser")}
                        </Button>
                      )}
                      {addNewUser && (
                        <PersonalDetails
                          mailext={this.props.users[0].emailId.substring(
                            this.props.users[0].emailId.indexOf("@") + 1
                          )}
                          selectedIndex={users.length}
                          history={history}
                          accesses={accesses}
                          setShowAllUsers={setShowAllUsers}
                          showAllUsers={true}
                          additionalNewUser={true}
                          setUsers={setUsers}
                          modifyUser={this.props.modifyUser}
                        />
                      )}
                      <hr />
                      <div className="row">
                        <div className="col-md-12 col-xs-12">
                          <div className="float-right">
                            <div className="float-left">
                              <Button
                                styleType="secondary"
                                onClick={this.handleBackButton}
                                className="margin-2-t margin-1-r"
                              >
                                {t("access.returnUserDetails")}
                              </Button>
                            </div>
                            <div className="float-right">
                              <Button
                                styleType="primary"
                                onClick={() => {
                                  this.Next();
                                }}
                                className="margin-2-t approvalRequestBtn"
                              >
                                {modifyUser
                                  ? t("newuser.modifyNext")
                                  : t("newuser.next")}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        <div className="bottomLine"></div>
      </>
    );
  }
}

export default withTranslation("common")(PersonalDetailsAccordianComponent);
